import React, { Component, useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Container,
  Divider,
  Button,
  Typography,
  Grid,
  IconButton,
  MobileStepper,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';
import { isHebrew } from '../../App';

import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { Hero } from './components/HeroSection';
import { BulletsSection } from './components/BulletsSection';
import { FormSection } from './components/FormSection';
import { FAQSection } from './components/FAQSection';
import { CaseStudiesSection } from './components/CaseStudiesSection';
import { NewFooter } from '../../components/NewFooter';
import { CustomersSection } from './components/CustomersSection';
import { lclDirection } from '../../utils/vlStrings';
import { Topbar } from './components/TopBar';
import LoadingOverlay from '../../components/Modal/Loading/LoaderOverlay';
import { Helmet } from 'react-helmet';
import { analytics, AnalyticsEvent } from '../../utils/analytics';

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#0e091e',
    minHeight: '100vh',
  },
  hero: {
    minHeight: '70vh',
  },
  topBar: {},
  buttons: {
    fontFamily: 'Assistant',
    padding: theme.spacing(1.5),
    textTransform: 'none',
  },
  pageSection: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
  },
  customers: {
    height: '60px',
  },

  textDetail: {
    color: 'rgba(255, 255, 255, 0.8)',
  },
  bottomCtaContainer: {
    minHeight: '420px',
    background:
      'linear-gradient(0deg, rgba(93,54,189,1) 0%, rgba(255,190,142,1) 100%)',
    [theme.breakpoints.down('xs')]: {
      minHeight: '320px',
    },
  },
}));

const HeadingText = (props) => {
  return (
    <Typography variant="h6">
      <Box lineHeight={1.2} fontWeight="bold" color="white" {...props}>
        {props.children}
      </Box>
    </Typography>
  );
};

const BodyText = (props) => {
  const classes = useStyles({ isHebrew: isHebrew() });
  return (
    <Typography variant="body2">
      <Box lineHeight={1.4} className={classes.textDetail} {...props}>
        {props.children}
      </Box>
    </Typography>
  );
};

const BottomCTA = (props) => {
  const { t, i18n } = useTranslation();
  const classes = useStyles({ isHebrew: isHebrew() });
  return (
    <Box
      mt={4}
      mb={4}
      className={classes.bottomCtaContainer}
      borderRadius="24px"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="h5">
          <Box
            maxWidth="420px"
            fontWeight="bold"
            ml={0.5}
            mr={0.5}
            lineHeight={1.2}
            textAlign="center"
            color="white"
            fontSize="32px"
          >
            {t('biz_lp_cta_banner_title')}
          </Box>
        </Typography>
        <Box mt={2} color="white" minWidth="200px">
          <Button
            onClick={() => props.onCTAClicked()}
            fullWidth={true}
            style={{ border: '2px solid' }}
            disableElevation
            className={classes.buttons}
            color="inherit"
            variant="outlined"
            id="cta-button-bottom"
          >
            {t('biz_lp_top_bar_contact_a_rep')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
const Footer = () => {
  return <NewFooter theme="dark" />;
};

const PageSection = (props) => {
  const classes = useStyles({ isHebrew: isHebrew() });
  return <Box className={classes.pageSection}>{props.children}</Box>;
};

const scrollTo = (ref) => {
  if (ref && ref.current /* + other conditions */) {
    ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
};
const BusinessLandingPage = (props) => {
  const classes = useStyles({ isHebrew: isHebrew() });
  const { i18n } = useTranslation();
  const theme = useTheme();
  const [showLoading, setShowLoading] = useState(true);
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const formSectionRef = useRef(null);

  useEffect(() => {
    if (props.heb || true) {
      i18n.changeLanguage('he');
      setTimeout(() => {
        setShowLoading(false);
      }, 300);
    } else {
      setShowLoading(false);
    }
    analytics.event(
      new AnalyticsEvent('web - flow - business landing - start')
    );
  }, []);

  const onScrollToForm = () => {
    scrollTo(formSectionRef);
  };

  const is_heb = isHebrew();
  const headerTitle = is_heb
    ? 'נצלו את הכוח של סרטוני וידאו קצרים מיוצרים. הרשמו היום להתנסות'
    : 'Utilize the power of short form videos from creators at scale. Get started today!';

  return (
    <div>
      <Helmet>
        <title>{headerTitle}</title>
      </Helmet>
      <Box className={classes.root} dir={is_heb ? 'rtl' : 'ltr'}>
        <Box visibility={showLoading ? 'hidden' : 'visible'}>
          <Topbar onCTAClicked={() => onScrollToForm()} />

          <Container>
            <PageSection>
              <Hero isSmall={isSmall} />
            </PageSection>
            <PageSection>
              <BulletsSection />
            </PageSection>
            <PageSection>
              <CaseStudiesSection />
            </PageSection>
          </Container>
          <PageSection>
            <CustomersSection />
          </PageSection>
          <Container>
            <PageSection>
              <FormSection scrollToRef={formSectionRef} />
            </PageSection>
            <PageSection>
              <FAQSection />
            </PageSection>
            <PageSection>
              <BottomCTA onCTAClicked={() => onScrollToForm()} />
            </PageSection>
          </Container>
          <Footer />
        </Box>
      </Box>
      <LoadingOverlay showLoading={showLoading} />
    </div>
  );
};
export default BusinessLandingPage;
